const WORDS = [
  "Angkor Wat",
  "Apsara Devata",
  "Khmer Kings",
  "Royal Dance",
  "French Indochina",
  "Ancient Inscriptions",
  "DatAsia Editions",
];

export const Marquee = () => {
  const row = [...WORDS, ...WORDS];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative border-y border-[var(--border-c)] bg-[var(--surface)] py-6 overflow-hidden"
    >
      <div className="marquee-track">
        {row.map((w, i) => (
          <span key={i} className="flex items-center shrink-0">
            <span className="font-serif text-2xl sm:text-3xl italic text-[var(--text-2)] px-8">
              {w}
            </span>
            <span className="h-2 w-2 rotate-45 bg-[var(--gold)]" />
          </span>
        ))}
      </div>
    </div>
  );
};
